





































































import {Component, Vue} from 'vue-property-decorator'
import {appointment, user, userObject} from "@/store/types";
import {MutationList as RootMutations} from "@/store/modules/root/mutation-list";
import {MutationList as UserMutations} from "@/store/modules/user/mutation-list";

@Component
export default class Confirmation extends Vue {

    private userNamespace = 'user/';
    private rootNamespace = 'root/';

    // Main user data
    get user(): userObject {
        return this.$store.getters[`${this.userNamespace}getUserData`]
    }

    // User selected appointments
    get userAppointments(): appointment[] {
        return this.$store.getters[`${this.userNamespace}getUserAppointments`]
    }

    //relatives
    get relativeUsers(): user[] {
        return this.$store.getters[`${this.userNamespace}getUserList`];
    }

    // Chosen appointments (not selected)
    get appointmentList(): appointment[] {
        return this.$store.getters[`${this.rootNamespace}getAppointmentList`];
    }

    // self explanatory
    addAppointmentToRelative(appointment: appointment, user: number, appIndex: number): void {
        this.$store.commit(`${this.userNamespace}${UserMutations.SAVE_APPOINTMENT_TO_RELATIVE}`, {
            user: user,
            appointment: appointment
        });
        this.$store.commit(`${this.rootNamespace}${RootMutations.SPLICE_APPOINTMENT_FROM_APPOINTMENT_ARRAY}`, appIndex);
    }

    // self explanatory
    deleteAppointmentFromRelative(appointment: appointment, user: number, appIndex: number): void {
        this.$store.commit(`${this.userNamespace}${UserMutations.DELETE_APPOINTMENT_FROM_RELATIVE}`, {
            user: user,
            appointment: appIndex
        });
        this.$store.commit(`${this.rootNamespace}${RootMutations.SAVE_APPOINTMENT}`, appointment);
    }

    addAppointmentToUser(appointment: appointment, appIndex: number): void {
        this.$store.commit(`${this.userNamespace}${UserMutations.SAVE_APPOINTMENT_TO_USER}`, appointment);
        this.$store.commit(`${this.rootNamespace}${RootMutations.SPLICE_APPOINTMENT_FROM_APPOINTMENT_ARRAY}`, appIndex);
    }

    deleteAppointmentFromUser(appointment: appointment, appIndex: number): void {
        this.$store.commit(`${this.userNamespace}${UserMutations.DELETE_APPOINTMENT_FROM_USER}`, appIndex);
        this.$store.commit(`${this.rootNamespace}${RootMutations.SAVE_APPOINTMENT}`, appointment);
    }
}
